import React from 'react';
import { formatUTC, getTimezoneTooltip } from '../../utils/timeUtils';
import './UTCTime.css';

interface UTCTimeProps {
  date: string | Date;
  format?: string;
}

function UTCTime({ date, format = 'dd MMM yyyy HH:mm' }: UTCTimeProps) {
  const formattedTime = formatUTC(date, format);
  const tooltipText = getTimezoneTooltip(date);

  return (
    <span className="utc-time" title={tooltipText}>
      {formattedTime}
    </span>
  );
}

export default UTCTime;
